import { backendHost, teacherServiceURL } from '../endpoint';

export function baseRoomsPythonURL() {
  const url = new URL(backendHost);
  url.pathname += 'rooms/api/';
  return url;
}

export function getRoomsListURL() {
  const url = baseRoomsPythonURL();
  url.pathname += 'list/';
  return url;
}

export function postRoomShareCodeURL() {
  const url = baseRoomsPythonURL();
  url.pathname += 'share/';
  return url;
}

export function baseRoomsNodeURL() {
  const url = new URL(teacherServiceURL);
  url.pathname += 'rooms/';
  return url;
}

export function roomUrl(roomId: number) {
  const url = baseRoomsNodeURL();
  url.pathname += String(roomId) + '/';
  return url;
}

export function getRoomShareCodeURL(roomId: number) {
  const url = roomUrl(roomId);
  url.pathname += 'url/';
  return url;
}

export function getClearRoomURL() {
  const url = baseRoomsPythonURL();
  url.pathname += 'clear/';
  return url;
}
